/**
 * Table | Bracket modal for a generic tournament (specs/champions-league, Stories 5 & 6, revised).
 *
 * The table and the bracket started as two top-level tabs. They are reference material, not
 * places you *do* something — Picks, Leaderboard and Squads are — and putting them in the tab bar
 * pushed a tournament to five tabs while the World Cup, the richer competition, has three. The
 * World Cup already answered this: one Table button in the header opening a modal whose own
 * toggle holds both views. This is that answer, generalised.
 */

export const COMPETITION_STANDINGS_MODAL_TEST_ID = 'competition-standings-modal';

export const COMPETITION_STANDINGS_VIEWS = {
  TABLE: 'table',
  BRACKET: 'bracket',
} as const;

export type CompetitionStandingsModalView =
  (typeof COMPETITION_STANDINGS_VIEWS)[keyof typeof COMPETITION_STANDINGS_VIEWS];

export const COMPETITION_STANDINGS_MODAL_COPY = {
  TITLE: 'STANDINGS',
  TABLE_TAB: 'Table',
  BRACKET_TAB: 'Bracket',
  ACCESSIBILITY_OPEN: 'Open standings and bracket',
  ACCESSIBILITY_CLOSE: 'Close standings',
} as const;
